"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useRef, useState, useEffect } from "react";
import { AuthContext } from "@/components/auth/Auth";
const ACCEPTED_FORMATS = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];
const ACCEPTED_FORMATS_DISPLAY = ACCEPTED_FORMATS.map(format => `.${format.replace("image/", "")}`).join(", ");
const FILE_SIZE_LIMIT = 2097152;
export default function UserSettingsImgSelectFile(t0) {
  const $ = _c(28);
  const {
    imageToShow,
    setFile
  } = t0;
  const {
    setToast
  } = useContext(AuthContext);
  const inputRef = useRef(null);
  const [error, setError] = useState(null);
  const [shake, setShake] = useState(false);
  let t1;
  if ($[0] !== setFile || $[1] !== setToast) {
    t1 = file => {
      setError(null);
      if (ACCEPTED_FORMATS.indexOf(file.type) === -1) {
        setError(null);
        setToast({
          type: "error",
          message: "Invalid file type"
        });
      } else {
        if (file.size > FILE_SIZE_LIMIT) {
          setError("File size must be less than 2MB");
          setShake(true);
        } else {
          setError(null);
          setFile(file);
        }
      }
    };
    $[0] = setFile;
    $[1] = setToast;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onFileChange = t1;
  let t2;
  if ($[3] !== onFileChange) {
    t2 = e => {
      e.preventDefault();
      e.stopPropagation();
      if (e?.dataTransfer?.files?.length) {
        onFileChange(e.dataTransfer.files[0]);
      }
    };
    $[3] = onFileChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleDrop = t2;
  const [dragging, setDragging] = useState(false);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e_0 => {
      e_0.preventDefault();
      e_0.stopPropagation();
      if (e_0.type === "dragenter" || e_0.type === "dragover") {
        setDragging(true);
      } else {
        if (e_0.type === "dragleave") {
          setDragging(false);
        } else {
          if (e_0.type === "drop") {
            setDragging(false);
          }
        }
      }
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleDrag = t3;
  let t4;
  let t5;
  if ($[6] !== shake) {
    t4 = () => {
      if (shake) {
        const timeout = setTimeout(() => setShake(false), 300);
        return () => clearTimeout(timeout);
      }
    };
    t5 = [shake];
    $[6] = shake;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  const t6 = ` ${dragging ? "tw-border-iron-600 tw-bg-iron-800" : "tw-border-iron-700 tw-bg-iron-900"} tw-relative tw-flex tw-h-64 tw-w-full tw-cursor-pointer tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-border-2 tw-border-dashed tw-transition tw-duration-300 tw-ease-out hover:tw-border-iron-600 hover:tw-bg-iron-800 ${shake ? "tw-animate-shake" : ""} `;
  let t7;
  if ($[9] !== imageToShow) {
    t7 = imageToShow && <div className="tw-h-40 tw-w-40"><img src={imageToShow} alt="Profile image" className="tw-h-full tw-w-full tw-rounded-sm tw-object-contain" /></div>;
    $[9] = imageToShow;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== imageToShow) {
    t8 = !imageToShow && <><div className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-transition tw-duration-300 tw-ease-out group-hover:tw-bg-iron-800"><div className="tw-flex tw-h-5 tw-w-5 tw-flex-shrink-0 tw-items-center tw-justify-center tw-text-iron-50"><svg className="tw-h-6 tw-w-6 tw-flex-shrink-0 tw-text-iron-50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div></div><p className="tw-mb-2 tw-mt-4 tw-text-sm tw-font-normal tw-text-iron-400"><span className="tw-font-medium tw-text-white">Click to upload</span>{" "}or drag and drop</p><p className="tw-text-xs tw-font-normal tw-text-iron-400">JPEG, JPG, PNG, GIF, WEBP</p></>;
    $[11] = imageToShow;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== error) {
    t9 = error && <p className="tw-absolute tw-bottom-2 tw-left-0 tw-w-full tw-text-center tw-text-xs tw-font-medium tw-text-red">{error}</p>;
    $[13] = error;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
    t10 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pb-6 tw-pt-5">{t7}{t8}{t9}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== onFileChange) {
    t11 = <input id="pfp-upload-input" ref={inputRef} type="file" className="tw-hidden" accept={ACCEPTED_FORMATS_DISPLAY} onChange={e_1 => {
      if (e_1.target.files) {
        const f = e_1.target.files[0];
        onFileChange(f);
      }
    }} />;
    $[19] = onFileChange;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t6) {
    t12 = <label className={t6}>{t10}{t11}</label>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t6;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== handleDrop || $[26] !== t12) {
    t13 = <div onDrop={handleDrop} onDragEnter={handleDrag} onDragLeave={handleDrag} onDragOver={handleDrag} className="tw-group tw-flex tw-w-full tw-items-center tw-justify-center">{t12}</div>;
    $[25] = handleDrop;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}